(function() {
  'use strict';
  
  const ACTIVE_GAME = {
    barName: 'Raspberry Special',
    
    clues: [
      'Inspired by classic British summer hedgerows.',
      'A natural sharpness that cuts through dark chocolate.',
      'You might find this in a jam, a crumble, or a trifle.'
    ],
    
    question: 'What flavour did our chocolatiers create this week?',
    
    correctAnswer: 'Raspberry',
    
    options: [
      'Strawberry',
      'Raspberry',
      'Blackberry',
      'Cherry'
    ]
  };
  
  const DEBUG_ALLOW_REPLAY = true;
  
  const STORAGE_KEY = 'bb_cluebar_state';
  const URL_PARAM_PLAY = 'game';
  const URL_PARAM_UNLOCK = 'unlock';
  const URL_PARAM_VALUE = 'cluebar';
  
  let attemptsUsed = 0;
  
  function getUrlParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  }
  
  function getState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }
  
  function saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }
  
  function grantUnlock() {
    const state = getState();
    state.lastUnlock = {
      barName: ACTIVE_GAME.barName,
      unlockedAt: Date.now()
    };
    saveState(state);
    
    try {
      localStorage.setItem('bb_special_unlocked', '1');
    } catch (e) {}
    
    if (typeof window.unlockSpecial === 'function') {
      window.unlockSpecial(false);
    }
    
    window.dispatchEvent(new CustomEvent('bb:special-bar-unlocked', {
      detail: { barName: ACTIVE_GAME.barName }
    }));
  }
  
  function hasPlayedThisWeek() {
    if (DEBUG_ALLOW_REPLAY) return false;
    
    const state = getState();
    if (!state.lastPlay) return false;
    if (state.lastPlay.barName !== ACTIVE_GAME.barName) return false;
    return true;
  }
  
  function recordPlay() {
    const state = getState();
    state.lastPlay = {
      barName: ACTIVE_GAME.barName,
      playedAt: Date.now()
    };
    saveState(state);
  }
  
  function showOverlay() {
    document.getElementById('clueGameOverlay').classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
function hideOverlay() {
  const overlay = document.getElementById('clueGameOverlay');
  
  overlay.style.opacity = '0';
  
  setTimeout(function() {
    overlay.classList.remove('active');
    overlay.style.opacity = '';
    document.body.style.overflow = '';
  }, 600);
}
  
  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
  
  function renderGame() {
    attemptsUsed = 0;
    
    const content = document.getElementById('clueGameContent');
    content.innerHTML = `
      <div class="clue-game-header">This Week's Special</div>
      <h2 class="clue-game-title" id="clueGameTitle">Guess the Flavour, Unlock the Bar</h2>
      
      <div class="clue-game-clues">
        ${ACTIVE_GAME.clues.map(c => `<p class="clue-game-clue">${escapeHtml(c)}</p>`).join('')}
      </div>
      
      <div class="clue-game-question">${escapeHtml(ACTIVE_GAME.question)}</div>
      
      <div class="clue-game-attempts" id="clueAttempts">2 attempts</div>
      
      <div class="clue-game-options" id="clueOptions">
        ${ACTIVE_GAME.options.map(opt => 
          `<button class="clue-game-option" data-answer="${escapeHtml(opt)}">${escapeHtml(opt)}</button>`
        ).join('')}
      </div>
      
      <div class="clue-game-feedback" id="clueFeedback"></div>
    `;
    
    document.querySelectorAll('.clue-game-option').forEach(btn => {
      btn.addEventListener('click', handleAnswer);
    });
  }
  
  function handleAnswer(e) {
    const button = e.currentTarget;
    const answer = button.dataset.answer;
    const isCorrect = answer === ACTIVE_GAME.correctAnswer;
    
    attemptsUsed++;
    
    if (isCorrect) {
      handleWin(button);
    } else {
      handleWrong(button);
    }
  }
  
  function handleWin(button) {
    button.classList.add('correct');
    
    document.querySelectorAll('.clue-game-option').forEach(b => {
      b.disabled = true;
    });
    
    recordPlay();
    grantUnlock();
    
    setTimeout(showWinScreen, 800);
  }
  
  function handleWrong(button) {
    button.classList.add('eliminated');
    button.disabled = true;
    
    if (attemptsUsed === 1) {
      const feedback = document.getElementById('clueFeedback');
      feedback.className = 'clue-game-feedback active warning';
      feedback.innerHTML = '<strong>Ok, just this time, we\'ll give you another go.</strong><br>Have another look at the clues.';
      
      document.getElementById('clueAttempts').textContent = '1 attempt left';
    } else {
      recordPlay();
      
      document.querySelectorAll('.clue-game-option').forEach(b => {
        if (b.dataset.answer === ACTIVE_GAME.correctAnswer) {
          b.classList.add('correct');
        } else {
          b.disabled = true;
        }
      });
      
      setTimeout(showFailScreen, 1200);
    }
  }
  
  function showWinScreen() {
    const content = document.getElementById('clueGameContent');
    content.innerHTML = `
      <div class="clue-game-header">You got it!</div>
      <h2 class="clue-game-title">Welcome to the inner circle.</h2>
      
      <div class="clue-game-bar-reveal">
        🎉 ${escapeHtml(ACTIVE_GAME.barName)} unlocked
      </div>
      
      <p style="margin: 0 0 16px; color: #555;">
        Your special bar is now available in your box. Build away.
      </p>
      
      <button class="clue-game-cta" id="clueWinCta">Build My Box</button>
    `;
    
document.getElementById('clueWinCta').addEventListener('click', function() {
  // Clean up the URL so refreshing doesn't re-trigger the game
  if (window.history && window.history.replaceState) {
    window.history.replaceState({}, '', window.location.pathname);
  }
  
  // Update the prefill quantities to include the newly-unlocked special
  if (typeof window.applyDefaultPrefill === 'function') {
    window.applyDefaultPrefill();
  }
  
  hideOverlay();
});
    
    launchFireworks();
  }
  
  function launchFireworks() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    
    const canvas = document.getElementById('clueFireworks');
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    
    canvas.classList.add('active');
    
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    
    const particles = [];
    const colors = ['#ff6b6b', '#feca57', '#48dbfb', '#1dd1a1', '#ff9ff3', '#f368e0', '#ffd93d', '#6bcf7f'];
    
    function createFirework(x, y) {
      const particleCount = 50 + Math.floor(Math.random() * 30);
      const color = colors[Math.floor(Math.random() * colors.length)];
      
      for (let i = 0; i < particleCount; i++) {
        const angle = (Math.PI * 2 * i) / particleCount;
        const velocity = 3 + Math.random() * 4;
        
        particles.push({
          x: x,
          y: y,
          vx: Math.cos(angle) * velocity,
          vy: Math.sin(angle) * velocity,
          alpha: 1,
          decay: 0.008 + Math.random() * 0.012,
          size: 3 + Math.random() * 3,
          color: color,
          gravity: 0.08
        });
      }
    }
    
    let startTime = Date.now();
    let lastFireworkTime = 0;
    let animationId;
    
    function animate() {
      const elapsed = Date.now() - startTime;
      
      if (elapsed > 4000) {
        cancelAnimationFrame(animationId);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.classList.remove('active');
        return;
      }
      
      if (elapsed < 2500 && elapsed - lastFireworkTime > 300) {
        const x = canvas.width * (0.1 + Math.random() * 0.8);
        const y = canvas.height * (0.15 + Math.random() * 0.5);
        createFirework(x, y);
        lastFireworkTime = elapsed;
      }
      
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        
        p.vy += p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.alpha -= p.decay;
        
        if (p.alpha <= 0) {
          particles.splice(i, 1);
          continue;
        }
        
        ctx.save();
        ctx.globalAlpha = p.alpha;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
      
      animationId = requestAnimationFrame(animate);
    }
    
    createFirework(canvas.width * 0.25, canvas.height * 0.3);
    createFirework(canvas.width * 0.75, canvas.height * 0.3);
    
    animate();
  }
  
  function showFailScreen() {
    const content = document.getElementById('clueGameContent');
    content.innerHTML = `
      <div class="clue-game-header">Not this time</div>
      <h2 class="clue-game-title">The answer was ${escapeHtml(ACTIVE_GAME.correctAnswer)}.</h2>
      
      <p style="margin: 0 0 20px; color: #555; line-height: 1.5;">
        Don't worry — we'll send the unlock to everyone in our 
        Wednesday newsletter. Keep an eye on your inbox.
      </p>
      
      <button class="clue-game-cta" id="clueFailCta">Continue Building My Box</button>
    `;
    
    document.getElementById('clueFailCta').addEventListener('click', hideOverlay);
  }
  
  function showDirectUnlockScreen() {
    grantUnlock();
    
    const content = document.getElementById('clueGameContent');
    content.innerHTML = `
      <div class="clue-game-header">Special Bar Unlocked</div>
      <h2 class="clue-game-title">${escapeHtml(ACTIVE_GAME.barName)}</h2>
      
      <div class="clue-game-bar-reveal">
        🎉 Now available in your box
      </div>
      
      <p style="margin: 0 0 16px; color: #555;">
        Build your box with this week's special bar included.
      </p>
      
      <button class="clue-game-cta" id="clueUnlockCta">Build My Box</button>
    `;
    
document.getElementById('clueUnlockCta').addEventListener('click', function() {
  if (window.history && window.history.replaceState) {
    window.history.replaceState({}, '', window.location.pathname);
  }
  
  if (typeof window.applyDefaultPrefill === 'function') {
    window.applyDefaultPrefill();
  }
  
  hideOverlay();
});
  }
  
  function showAlreadyPlayedScreen() {
    const content = document.getElementById('clueGameContent');
    content.innerHTML = `
      <div class="clue-game-header">You've already played this week</div>
      <h2 class="clue-game-title">See you next Monday.</h2>
      
      <p style="margin: 0 0 20px; color: #555; line-height: 1.5;">
        A new clue-bar game launches every Monday at 7pm.
      </p>
      
      <button class="clue-game-cta" id="cluePlayedCta">Continue</button>
    `;
    
    document.getElementById('cluePlayedCta').addEventListener('click', hideOverlay);
  }
  
  function init() {
    const overlay = document.getElementById('clueGameOverlay');
    if (!overlay) return;
    
    document.getElementById('clueGameClose').addEventListener('click', hideOverlay);
    
    overlay.addEventListener('click', function(e) {
      if (e.target === this) hideOverlay();
    });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') hideOverlay();
    });
    
    const gameParam = getUrlParam(URL_PARAM_PLAY);
    const unlockParam = getUrlParam(URL_PARAM_UNLOCK);
    
    if (unlockParam === URL_PARAM_VALUE) {
      showDirectUnlockScreen();
      showOverlay();
    } else if (gameParam === URL_PARAM_VALUE) {
      if (hasPlayedThisWeek()) {
        showAlreadyPlayedScreen();
      } else {
        renderGame();
      }
      showOverlay();
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();